module.exports = __webpack_public_path__ + "img/services.180fafef.webp";